import { create, toBinary } from '@bufbuild/protobuf'
import { base64Encode } from '@bufbuild/protobuf/wire'

import { InstrumentSelectionBlockerV3InstrumentOption } from '@cash-web/protos/squareup/franklin/blockers/instrument_selection_blocker_v3.pb'
import { CashInstrumentType as CashInstrumentTypeString } from '@cash-web/protos/squareup/franklin/cash_instrument_type.pb'
// eslint-disable-next-line no-restricted-imports -- Encoding functionality is needed here
import { InstrumentSelectionOptionSchema } from '@cash-web/protos-with-encode-methods/squareup/cash/plasma/common/InstrumentSelectionOption_pb'
// eslint-disable-next-line no-restricted-imports -- Encoding functionality is needed here
import { CashInstrumentType } from '@cash-web/protos-with-encode-methods/squareup/franklin/cash_instrument_type_pb'

function toNumericInstrumentType(stringType: CashInstrumentTypeString | undefined): CashInstrumentType | undefined {
  if (!stringType) return undefined
  return CashInstrumentType[stringType as keyof typeof CashInstrumentType]
}

export function encodeInstrumentSelectionOption(option: InstrumentSelectionBlockerV3InstrumentOption): string {
  if (option.select_instrument_action) {
    const msg = create(InstrumentSelectionOptionSchema, {
      selectionOption: {
        case: 'existingLink',
        value: {
          instrumentToken: option.select_instrument_action.instrumentToken ?? '',
          instrumentType: toNumericInstrumentType(option.select_instrument_action.instrumentType),
        },
      },
    })
    return base64Encode(toBinary(InstrumentSelectionOptionSchema, msg))
  }

  if (option.link_instrument_action) {
    const msg = create(InstrumentSelectionOptionSchema, {
      selectionOption: {
        case: 'newLink',
        value: {
          instrumentType: toNumericInstrumentType(option.link_instrument_action.instrumentType),
        },
      },
    })
    return base64Encode(toBinary(InstrumentSelectionOptionSchema, msg))
  }

  if (option.replace_instrument_action) {
    const msg = create(InstrumentSelectionOptionSchema, {
      selectionOption: {
        case: 'replaceLink',
        value: {
          instrumentToken: option.replace_instrument_action.instrumentToken ?? '',
          instrumentType: toNumericInstrumentType(option.replace_instrument_action.instrumentType),
        },
      },
    })
    return base64Encode(toBinary(InstrumentSelectionOptionSchema, msg))
  }

  throw new Error('InstrumentSelectionV3: option has no actionable selection')
}
